import { PopperTooltip, useClickOutside } from '@emarketer/componentlibrary';
import React, { useRef } from 'react';
import {
  PillTooltipContainer,
  PillTooltipLabel,
  PillTooltipCounter,
  PillTooltipWrapper,
  PillTooltipContainerTrigger,
} from './PillTooltip.styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { COLOR } from '../../../theme/constants';

export interface IPillTooltip {
  label: string;
  counter?: number;
  active?: boolean;
  show: boolean;
  setShow: any;
}

const PillTooltip: React.FC<IPillTooltip> = (props) => {
  const { label, counter, active, show, setShow } = props;
  const ref = useRef(null);
  useClickOutside(ref, () => setShow(false));

  return (
    <PillTooltipWrapper ref={ref}>
      <PopperTooltip
        controlShow
        showArrow
        showPopper={show}
        distance={20}
        placement="bottom-start"
        target={
          <PillTooltipContainerTrigger buttonType="none" callback={() => setShow(!show)}>
            <PillTooltipContainer active={active || show} flexDirection="row" spaceBetween={8}>
              <PillTooltipLabel>{label}</PillTooltipLabel>
              {counter && <PillTooltipCounter>{counter}</PillTooltipCounter>}
              <FontAwesomeIcon
                width={13.675}
                icon={faChevronDown}
                color={COLOR.BLUE}
                style={{
                  transform: show ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.2s',
                }}
              />
            </PillTooltipContainer>
          </PillTooltipContainerTrigger>
        }
      >
        {props.children}
      </PopperTooltip>
    </PillTooltipWrapper>
  );
};

export default PillTooltip;
